<template>
  <div class="brand-social">
    <div class="stats">
      <div
        class="like"
        :class="{ is_liked: page.is_liked }"
        @click="tryLike"
      >
        {{ kFormatter(page.likes) }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.804"
          height="15.731"
          viewBox="0 0 17.804 15.731"
        >
          <path
            d="M17.804 7.615a2.188 2.188 0 0 1-.109.333c-.1.2-.219.383-.323.578a.247.247 0 0 0-.039.178 1.765 1.765 0 0 1-.292 1.8.193.193 0 0 0-.041.218 1.727 1.727 0 0 1-.232 1.683.422.422 0 0 0-.084.387 1.888 1.888 0 0 1-.446 1.853 1.635 1.635 0 0 1-.892.474 5.151 5.151 0 0 1-.915.1H7.655a2.075 2.075 0 0 1-1.143-.373.428.428 0 0 0-.339-.086 2.441 2.441 0 0 1-.027.326.713.713 0 0 1-.654.64 1.408 1.408 0 0 1-.155 0H.827a.763.763 0 0 1-.823-.7V7.928a.795.795 0 0 1 .835-.845h5.088a2.851 2.851 0 0 1 .357.068.243.243 0 0 0 .178-.021 5.533 5.533 0 0 0 .519-.58 23.722 23.722 0 0 0 1.851-3.04 1.1 1.1 0 0 0 .134-.569c-.023-.587-.023-1.176-.047-1.762a.974.974 0 0 1 .515-.927 1.9 1.9 0 0 1 2.063.114 1.176 1.176 0 0 1 .322.475c.219.535.428 1.082.613 1.633a3.532 3.532 0 0 1 .075 1.851c-.093.469-.16.943-.241 1.414-.027.16-.021.178.143.178h3.854a1.649 1.649 0 0 1 .892.212 1.347 1.347 0 0 1 .594.849c.014.055.032.109.048.162v.483Zm-6.457-.963c.139-.826.28-1.633.408-2.441a3.594 3.594 0 0 0 .08-.87 7.146 7.146 0 0 0-.7-2.2.535.535 0 0 0-.4-.357 1.206 1.206 0 0 0-.892.078.319.319 0 0 0-.194.325q.036.974.036 1.947a1.325 1.325 0 0 1-.077.455 3.122 3.122 0 0 1-.26.535c-.535.876-1.07 1.755-1.619 2.62a3.355 3.355 0 0 1-.958 1.07c-.253.164-.508.332-.754.5a.242.242 0 0 0-.1.164v5.289c0 .105.045.116.136.127a2.569 2.569 0 0 1 .506.105 1.4 1.4 0 0 1 .316.191 1.577 1.577 0 0 0 .909.273h6.712a3.057 3.057 0 0 0 .4-.023 1.163 1.163 0 0 0 .824-.476.815.815 0 0 0 .046-1 2.173 2.173 0 0 0-.412-.312.32.32 0 0 1 .114-.123 1.154 1.154 0 0 0 .831-.8.722.722 0 0 0-.228-.829 2.965 2.965 0 0 0-.4-.219.513.513 0 0 1 .159-.153 1.1 1.1 0 0 0 .678-.483.783.783 0 0 0-.357-1.273.155.155 0 0 1-.093-.1.132.132 0 0 1 .114-.148 1.109 1.109 0 0 0 .851-.958.713.713 0 0 0-.389-.822 1.307 1.307 0 0 0-.5-.093h-4.8ZM5.26 7.841c-.057 0-.1-.009-.141-.009H.897a.123.123 0 0 0-.152.153v6.856a.135.135 0 0 0 .166.168h4.166c.178 0 .178 0 .178-.187V7.846Z"
            fill="#363636"
          />
        </svg>
      </div>
      <div
        v-if="page.hide_comments === false"
        class="comment"
        @click="tryComment"
      >
        {{ kFormatter(page.commentsCount) }}
        <img
          src="~assets/icons/comment.svg"
          alt="commentaires"
        />
      </div>
      <div
        class="share"
        :class="{ showShare }"
        @click="showShare = !showShare"
      >
        {{ kFormatter(page.shares) }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.866"
          height="11.931"
          viewBox="0 0 17.866 11.931"
        >
          <path
            d="M12.987,36.781a.4.4,0,0,0,.326-.15,8.9,8.9,0,0,1,5.258-2.7,16.855,16.855,0,0,1,4.031-.275.087.087,0,0,0,.05.025v2.479a.655.655,0,0,0,.376.551.456.456,0,0,0,.526-.125l6.686-5.659a.438.438,0,0,0,0-.7l-6.661-5.283a.64.64,0,0,0-.6-.025.561.561,0,0,0-.3.476v2.454l-.05.05c-7.562,1.4-9.565,5.834-10.066,8.338h0a.439.439,0,0,0,.25.5A.464.464,0,0,0,12.987,36.781Zm9.74-8.388a.59.59,0,0,0,.451-.5v-2.5a.191.191,0,0,1,.125-.05l6.61,5.233-6.661,5.659-.025.025a.19.19,0,0,1-.05-.1v-2.5a.585.585,0,0,0-.476-.5c-.175,0-.5-.025-.926-.025a17.139,17.139,0,0,0-3.255.3,9.678,9.678,0,0,0-5.434,2.729C13.639,33.727,15.642,29.72,22.728,28.393Z"
            transform="translate(-12.549 -24.85)"
            fill="#363636"
          />
        </svg>
      </div>
    </div>
    <ShareItem
      v-if="showShare"
      :share="{
        title: page.title,
        slug: page.slug,
      }"
    />
    <template v-if="page.hide_comments === false">
      <div
        v-if="!authenticated"
        class="comment-cta"
      >
        <h2 class="title-strat">commenter cette publication ?</h2>
        <ButtonSimple
          label="Se connecter"
          @click="loginModal.open()"
        />
      </div>
      <div
        v-else
        class="editor-comment"
      >
        <h2 class="title-strat">Votre commentaire</h2>
        <div class="comment-section">
          <div
            v-if="auth.data.value?.avatar"
            class="user-image"
          >
            <img
              :src="auth.data.value?.avatar.url"
              alt=""
              loading="lazy"
            />
          </div>
          <div class="editor-content">
            <TheEditor
              ref="editorPost"
              v-model="contentEditor"
              :list="false"
              :mention="true"
              :wapers-suggestions="wapersSuggestions"
            />
            <span
              v-if="errors.content"
              class="c-form__feedback is-invalid"
            >
              {{ errors.content }}
            </span>
          </div>
        </div>
        <div
          class="button"
          :class="{ disabled: !canComment }"
          @click="submitComment"
        >
          Publier
        </div>
      </div>
      <div class="comments-container">
        <div
          v-if="page.comments?.length"
          class="sort-container"
        >
          <div class="sort">
            <select
              v-model="sortReview"
              class="c-form__select"
              @change="onSortChange"
            >
              <option value="date">Trier par date</option>
              <option value="popularity">Trier par popularité</option>
            </select>
          </div>
        </div>
        <PostCommentItem
          v-for="comment in page.comments"
          :key="comment.id"
          :comment="{ ...comment, slugParent: page.slug }"
        />
      </div>
      <div
        v-if="page.has_more_comments"
        class="more-comments"
        @click="socialStore.showMoreContent()"
      >
        Voir plus de commentaires
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type TheEditorComponent from '@/components/shared/Editor/TheEditor.vue'
import { checkLoginModal } from '~/modals/checkLogin'
import { loginModal } from '~/modals/login'
import type { FormattedArticle, SocialSortReviews } from '~/types'

// tiptap/ProseMirror (about 100 KB compressed) loaded when an editor is shown, not with the page
const TheEditor = defineAsyncComponent(
  () => import('@/components/shared/Editor/TheEditor.vue'),
)

const props = defineProps<{
  page: FormattedArticle
}>()

const auth = useAuth()
const showShare = ref(false)

const wapersStore = useWapersStore()
const wapersSuggestions = computed(() => {
  return wapersStore.userWapers.map((waper, index) => {
    return {
      id: index,
      name: waper.nickname,
      userId: waper.id,
      slug: waper.slug,
    }
  })
})

const socialStore = useSocialStore()
const sortReview = ref<SocialSortReviews>('popularity')

const onSortChange = async () => {
  await socialStore.updateSortComments({ sort: sortReview.value })
  return socialStore.refreshCommentsAction()
}

const { authenticated } = useAuthenticated()
const editorPost = ref<InstanceType<typeof TheEditorComponent> | null>(null)

const tryComment = () => {
  if (authenticated.value) {
    track('social', {
      interaction: 'comment',
      target_url: props.page.slug,
    })

    return editorPost.value?.editor?.commands.focus()
  }
  return checkLoginModal.open()
}

const canComment = ref(true)
const contentEditor = ref('')
const errors = ref<{
  [key: string]: unknown
  content?: string
}>({})

const submitComment = async () => {
  if (!canComment.value) return

  canComment.value = false
  errors.value = {}

  const formData: {
    content: string
    [contentImage: string]: string | undefined
  } = {
    content: contentEditor.value,
  }

  const images = formData.content.match(
    /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/g,
  )

  if (images?.length) {
    images.forEach((image, index) => {
      formData.content = formData.content.replace(
        image,
        `<!-- contentImage${index + 1} -->`,
      )
      formData[`contentImage${index + 1}`] = image.match(
        /<img\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?>/,
      )?.[1]
    })
  }

  const embed = formData.content.match(
    /<iframe\s[^>]*?src\s*=\s*['"]([^'"]*?)['"][^>]*?><\/iframe>/,
  )

  if (embed) {
    formData.content = formData.content.replace(
      embed[0],
      '<!-- contentEmbed -->',
    )
    formData['contentEmbed'] = embed[1]
  }

  const { error } = await socialStore.postCommentContent({
    content: formData,
  })

  if (error) {
    const { statusCode, data } = error

    if (data.errors && statusCode && statusCode >= 400 && statusCode < 500) {
      Object.keys(data.errors).forEach((key) => {
        errors.value = {
          ...errors,
          [key]: data.errors[key].join(' '),
        }
      })
    }
    canComment.value = true
    return
  }

  contentEditor.value = ''
  editorPost.value?.editor?.commands.clearContent()
  canComment.value = true
}

const tryLike = async () => {
  if (!authenticated.value) {
    return checkLoginModal.open()
  }

  if (props.page.is_liked) {
    return socialStore.unlikeContent()
  }
  return socialStore.likeContent()
}
</script>

<style lang="scss" scoped>
.brand-social {
  .sort-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .sort {
    select {
      padding-right: 2rem;
      background-position: right center;
      border: 0;

      &:focus {
        box-shadow: none;
      }
    }
  }

  .more-comments {
    padding-top: 1rem;
    padding-bottom: 1rem;
    color: $blue;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
  }

  .editor-comment {
    display: flex;
    flex-direction: column;
    padding: 3rem 8rem;

    .comment-section {
      display: flex;
      width: 100%;
      margin-top: 2rem;
    }

    .user-image {
      width: 5.4rem;
      height: 5.4rem;
      margin-right: 3rem;
      overflow: hidden;
      background: #ccc;
      border-radius: 2.7rem;

      @media screen and (max-width: 430px) {
        display: none;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .editor-content {
      flex-grow: 1;
    }

    .button {
      display: inline-flex;
      align-items: center;
      align-self: flex-end;
      height: 4.6rem;
      margin-top: 3rem;
      padding: 0 2rem;
      color: $white;
      font-size: 1.5rem;
      font-weight: 500;
      background: $backgroundBlue;
      cursor: pointer;

      &.disabled {
        background-color: $lightGrey;
        cursor: not-allowed;
        opacity: 1;
      }
    }
  }

  .stats {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 5.7rem;
    border-top: 1px solid rgba($black, 0.2);
    border-bottom: 1px solid rgba($black, 0.2);

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 11.6rem;
      height: 100%;
      border-left: 1px solid rgba($black, 0.2);
      cursor: pointer;

      img,
      svg {
        margin-left: 1.4rem;
      }
    }

    .comment {
      img {
        width: 1.56rem;
        height: 1.317rem;
      }
    }

    .like {
      &.is_liked {
        color: $blue;

        svg {
          path {
            fill: $blue;
          }
        }
      }

      svg {
        width: 1.78rem;
        height: 1.57rem;
      }
    }

    .share {
      img {
        width: 1.787rem;
        height: 1.193rem;
      }

      &:hover {
        color: $blue;

        svg {
          path {
            fill: $blue;
          }
        }
      }

      &.showShare {
        color: $white;
        background: $blue;

        svg {
          path {
            fill: $white;
          }
        }
      }
    }

    .report {
      flex-grow: 1;
      justify-content: flex-start;

      &:hover {
        color: $blue;
      }
    }
  }

  .comment-cta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4.4rem;
    margin-bottom: 5rem;
    padding: 0 8rem;

    @media screen and (max-width: 1120px) {
      flex-direction: column;

      .title-strat {
        margin-bottom: 20px;
      }
    }
  }

  .comments-container {
    padding: 0 8rem;
  }
}

@media screen and (max-width: 700px) {
  .brand-social {
    .stats {
      flex-direction: column;
      height: auto;
      border-top: none;

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 5.7rem;
        border-top: 1px solid rgba($black, 0.2);
        border-left: none;

        img {
          margin-left: 1.4rem;
        }
      }

      .report {
        justify-content: center;
        border-top: none;
      }
    }

    .comment-cta {
      flex-direction: column;
      align-items: flex-start;
      margin-top: 2.5rem;
      margin-bottom: 2.5rem;
      padding: 0 2.5rem;

      .title-strat {
        margin-bottom: 1rem;
      }
    }

    .comments-container {
      padding: 0 2.5rem;
    }

    .editor-comment {
      padding: 3rem 2.5rem;
    }
  }
}

.is-invalid {
  display: block;
  color: #ea5151;
}
</style>
